import React from "react";
import styled from "styled-components";

const Container = styled.div<{ $miniMode?: boolean }>`
  height: ${({ $miniMode }) => ($miniMode ? "30px" : "50px")};

  & > svg {
    height: 100%;
    width: auto;
  }
`;

const PinkPin = ({ miniMode = false }: { miniMode?: boolean }) => (
  <Container $miniMode={miniMode}>
    <svg
      width="63"
      height="50"
      viewBox="0 0 63 50"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_2805_9199)">
        <g opacity="0.3" filter="url(#filter0_f_2805_9199)">
          <path
            d="M29.1762 27.4194C36.382 36.0522 31.9188 46.957 30.5665 47.3406C29.2142 47.7242 11.7405 43.0419 4.53474 34.409C0.00234988 28.979 1.8443 23.0125 8.64885 21.0823C15.4534 19.1522 24.6438 21.9894 29.1762 27.4194Z"
            fill="#1B1918"
          />
        </g>
        <path
          d="M31.25 3.08398C40.1325 3.08398 47.3338 10.2846 47.334 19.167C47.334 26.3481 43.6804 33.2694 39.7021 38.4541C37.7224 41.0342 35.6882 43.1494 34.0459 44.6113C33.2235 45.3434 32.5122 45.9008 31.9658 46.2676C31.6913 46.4518 31.4745 46.5765 31.3184 46.6514C31.2924 46.6638 31.269 46.6715 31.25 46.6797C31.2311 46.6715 31.2074 46.6637 31.1816 46.6514C31.0255 46.5764 30.8095 46.4517 30.5352 46.2676C29.9887 45.9008 29.2776 45.3435 28.4551 44.6113C26.8128 43.1494 24.7787 41.0343 22.7988 38.4541C18.8205 33.2694 15.167 26.3482 15.167 19.167C15.1672 10.2847 22.3677 3.08416 31.25 3.08398Z"
          fill="#D93075"
          stroke="#1B1918"
          strokeWidth="2"
        />
      </g>
      <defs>
        <filter
          id="filter0_f_2805_9199"
          x="0.383138"
          y="18.8099"
          width="34.4593"
          height="30.2191"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="BackgroundImageFix"
            result="shape"
          />
          <feGaussianBlur
            stdDeviation="0.833333"
            result="effect1_foregroundBlur_2805_9199"
          />
        </filter>
        <clipPath id="clip0_2805_9199">
          <rect width="62.0833" height="50" fill="white" />
        </clipPath>
      </defs>
    </svg>
  </Container>
);

export default PinkPin;
